import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { classNameWithModifiers } from 'helpers/utilities/utilities';
import './leftMarginSection.scss';
// ----- Component ----- //
export default function LeftMarginSection(props) {
    return (_jsx("section", { className: [
            props.className,
            classNameWithModifiers('component-left-margin-section', props.modifierClasses),
        ].join(' '), children: _jsx("div", { className: "component-left-margin-section__content", children: props.children }) }));
} // ----- Default Props ----- //
LeftMarginSection.defaultProps = {
    modifierClasses: [],
    className: null,
};
